var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUk = function SvgUk(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21730_20458",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#4171CF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21730_20458)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#6A97AE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.25,
    y: -4,
    width: 27.5,
    height: 26,
    fill: "#0A2378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.75 -3L16.25 7.5L9.58333 12.5L0 20.5L-6.25 21L8.33333 9.5L11.25 6.5L24.0705 -4L28.75 -3Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.2513 -2.14286L-1.66797 3.5L22.4987 21H27.082V20L-2.08463 -3L-6.2513 -2.14286Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.582 13L24.1654 20H24.9987V19.125L16.4868 13H14.582Z",
    fill: "#BD2E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.75 1L5.89286 8H6.66667V7.125L-1.25 1H-3.75Z",
    fill: "#BD2E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.668 7.5L23.3346 -2L23.7513 -1.5L12.5013 8L11.668 7.5Z",
    fill: "#BD2E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.33203 21L7.91797 12H9.16797L-1.66536 21H-3.33203Z",
    fill: "#BD2E33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.91797,
    y: -3,
    width: 4.16667,
    height: 27,
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.832,
    y: 7,
    width: 6,
    height: 27.5,
    transform: "rotate(90 25.832 7)",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 8.5,
    width: 3,
    height: 29,
    transform: "rotate(90 26 8.5)",
    fill: "#BD2E33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: -3,
    width: 2.5,
    height: 26,
    fill: "#BD2E33"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUk);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/uk.171c61a63c63f930a7220529eff2a864.svg";